import useSWR, {SWRConfiguration} from 'swr'
import useSWRImmutable from 'swr/immutable'

import authFetch from 'lib/utils/auth-fetch'

import useUser from './use-user'

export async function swrFetcher<T>([path, user]: [string, CL.User]) {
  const res = await authFetch<T>(path, user)
  if (res.ok === false) throw res
  return res.data
}

/**
 * A helper wrapper for simple SWR hooks that use `auth-fetch`
 */
export default function useAuthSWR<D, E = unknown>(
  path: string | null,
  config?: SWRConfiguration<D, E>
) {
  const {user} = useUser()
  return useSWR<D, E>(
    () => (path == null || user == null ? null : [path, user]),
    swrFetcher,
    config
  )
}

/**
 * A helper wrapper for simple SWR hooks that use `auth-fetch` and are immutable.
 */
export function useImmutableAuthSWR<T>(path?: string) {
  const {user} = useUser()
  return useSWRImmutable<T>(
    () => (path == null || user == null ? null : [path, user]),
    swrFetcher
  )
}
